var Marionette = require('marionette')
var tplSurvey = require('./templates/index.html')
var translations = require('../../libs/translationsUtils/translations')
var SurveyItemsCollectionView = require('./views/ItemsCollection')
var SurveyFooter = require('./views/Footer')
var ThankYou = require('./views/ThankYou')
var SurveyParticipation = require('./models/SurveyParticipation')
var events = require('utils/globalEvents')

module.exports = Marionette.LayoutView.extend({
  regions: {
    items: '.survey__items',
    footer: '.survey__footer'
  },

  events: {
    click: 'onWrapperClick'
  },

  onWrapperClick: function (e) {
    if (this.options.userIsGuest) {
      e.preventDefault()
      e.stopPropagation()
      events.commands.execute('modal:login:show')
    }
  },

  template: tplSurvey,

  setActiveItem: function () {
    var itemViews = this.getRegion('items').currentView.children._views
    var i = 0
    var current = this.model.get('current')

    for (var k in itemViews) {
      itemViews[k].$el.toggleClass('active', i === current)
      i++
    }
  },

  setItemValue: function (item, value) {
    var answersItem = this.model.get('answers').at(item)
    answersItem.set('value', value)
  },

  onRender: function () {
    this.getRegion('footer').show(
      new SurveyFooter({
        model: this.model,
        userIsGuest: this.options.userIsGuest
      })
    )

    if (this.model.get('hasParticipated')) {
      return this.getRegion('items').show(new ThankYou())
    }

    var items = this.model.get('form').get('items')
    if (!items.length) return

    var ItemsCollectionView = new SurveyItemsCollectionView({
      collection: items
    })

    this.listenTo(
      ItemsCollectionView,
      'item:value:changed',
      this.setItemValue.bind(this)
    )

    this.getRegion('items').show(ItemsCollectionView)

    this.setActiveItem()
  },

  render: function () {
    if (!this.model.get('form').get('items').length) return
    Marionette.LayoutView.prototype.render.apply(this, arguments)
  },

  initialize: function () {
    translations.addTranslationDict(this.options.translations)
    this.model = new SurveyParticipation({
      id: this.getOption('surveyId'),
      userIsGuest: this.options.userIsGuest,
      userId: this.options.userId
    })
    this.listenTo(this.model.get('form'), 'change', this.render.bind(this))
    this.listenTo(
      this.model.get('form').get('items'),
      'reset',
      this.render.bind(this)
    )
    this.listenTo(this.model, 'change:current', this.setActiveItem.bind(this))
    this.listenTo(this.model, 'change:hasParticipated', this.render.bind(this))
    this.model.fetch()
  }
})
